export class LayoutView {
    isMobile: boolean;
    isDesktop: boolean;
  
    constructor() {
      this.isMobile = false;
      this.isDesktop = true;
    }
  }